import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[mbsInputPrepend]'
})
export class InputPrependDirective {
  templateRef = inject<TemplateRef<any>>(TemplateRef);
}
